import { render, staticRenderFns } from "./PackageItem.vue?vue&type=template&id=1d21661a&scoped=true&"
import script from "./PackageItem.vue?vue&type=script&lang=js&"
export * from "./PackageItem.vue?vue&type=script&lang=js&"
import style0 from "./PackageItem.vue?vue&type=style&index=0&id=1d21661a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d21661a",
  null
  
)

export default component.exports